const breakpoints = {
  xs: {
    mini: 320,
    base: 360,
    plus: 480,
  },
  sm: {
    mini: 600,
    base: 720,
    plus: 768,
  },
};
